import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { changeLicenseSeatsAction } from '@/redux/actions/company';
import { changeLicenseSeats, TChangeLicenseSeatsResponse } from '@/services/api/company';

export function* changeLicenseSeatsSaga(action: ActionType<typeof changeLicenseSeatsAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(changeLicenseSeats, materials);
    const seatsResponse: TChangeLicenseSeatsResponse = response as TChangeLicenseSeatsResponse;
    yield put(changeLicenseSeatsAction.success(seatsResponse));
    successCallback?.(seatsResponse);
  } catch (err) {
    // The backend answers with a readable reason - more seats cancelled than
    // bought, or seats still assigned to users, for instance.
    handleAPIError(err, materials.direction === 'add' ? 'Billing.addSeatsError' : 'Billing.cancelSeatsError');
    yield put(changeLicenseSeatsAction.failure(err));
    failedCallback?.(err);
  }
}
